import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { PersistStateProvider } from './context/PersistStateContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <PersistStateProvider>
        <App />
      </PersistStateProvider>
    </AuthProvider>
  </React.StrictMode>
);